import React from 'react'
import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { RouteComponentProps, match as Match } from 'react-router-dom'

import { Container } from 'src/designSystem'
import { useFeatureFlag } from 'src/featureFlags'
import ParticipantList from 'src/participantsHome/ParticipantList'
import ParticipantListControls from 'src/participantsHome/ParticipantListControls'
import ParticipantInfo from '../components/ParticipantInfo'
import Participant from './Participant'

export type Props = RouteComponentProps<{ uid?: string }>

const PARTICIPANT_LIST_WIDTH = 440
const EXPANDED_PARTICIPANT_LIST_WIDTH = 980

const useStyles = makeStyles({
  wrappedText: { maxWidth: '300px' },
})

const MainView: React.FunctionComponent<Props> = ({ match }) => {
  const classes = useStyles()
  const { uid } = match.params
  const hasPriorityFilters = useFeatureFlag('featureFlagDashboardPriorityFilters')

  const sidebar = <ParticipantList selectedUid={uid} />
  const collapsedSidebarControl = hasPriorityFilters ? <ParticipantListControls /> : undefined
  const sidebarWidth = hasPriorityFilters ? PARTICIPANT_LIST_WIDTH : undefined
  const minExpandedSidebarWidth = hasPriorityFilters ? EXPANDED_PARTICIPANT_LIST_WIDTH : undefined

  return (
    <Container
      sidebar={sidebar}
      collapsedSidebarControl={collapsedSidebarControl}
      forceShowSidebar={hasPriorityFilters ? undefined : !uid}
      infoarea={uid ? <ParticipantInfo uid={uid} /> : undefined}
      sidebarWidth={sidebarWidth}
      minExpandedSidebarWidth={minExpandedSidebarWidth}
      selectedUid={uid}
    >
      {uid ? (
        <Participant match={match as Match<{ uid: string }>} uid={uid} />
      ) : (
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <Typography classes={{ root: classes.wrappedText }} align="center" variant="h3">
            Select a participant to view their records, chat messages and other activities
          </Typography>
        </Box>
      )}
    </Container>
  )
}

export default MainView
